module.exports = __webpack_public_path__ + "assets/img/hcpbt4.7d616a66.png";